export const Pinwheel = ({ className = "", size = 120 }) => (
    <svg
        viewBox="0 0 100 100"
        width={size}
        height={size}
        className={`orbit-slow ${className}`}
        fill="none"
        aria-hidden="true"
    >
        {[0, 90, 180, 270].map((r, i) => (
            <path
                key={r}
                d="M50 50 C50 22 66 8 90 10 C80 31 66 46 50 50 Z"
                fill={i % 2 === 0 ? "#F16622" : "#232B6B"}
                opacity="0.9"
                transform={`rotate(${r} 50 50)`}
            />
        ))}
    </svg>
);
